import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { FaWhatsapp, FaEnvelope } from "react-icons/fa";
import {
    Input,
    InputGroup,
    InputGroupText,
  } from 'reactstrap';
import "react-toastify/dist/ReactToastify.css";
import "./PembekalanWisuda.css"; // Anda bisa ubah ini jika nama file CSS beda
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from 'reactstrap';
import * as XLSX from "xlsx";

const API_URL = "https://graduation.rlagency.id/api/api-admin/get-pembekalan-register.php";
const UPDATE_API = "https://graduation.rlagency.id/api/api-admin/update-jam-kehadiran.php";
const ITEMS_PER_PAGE = 10;

const PembekalanWisuda = () => {
  const [dataWisuda, setDataWisuda] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedNim, setSelectedNim] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [resumeData, setResumeData] = useState({
    total: 0,
    awal: [],
    akhir: []
  });


  useEffect(() => {
    fetchDataWisuda();
  }, []);

  const fetchDataWisuda = async () => {
    setLoading(true);
    try {
      const response = await axios.get(API_URL);
      const sortedData = (response.data.data || []).sort((a, b) =>
        new Date(b.date_created) - new Date(a.date_created)
      );
      setDataWisuda(sortedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };  

  const handleUpdateKehadiran = async (nim) => {
    const now = new Date();
    const jakartaTime = new Date(
      now.toLocaleString("en-US", { timeZone: "Asia/Jakarta" })
    );

    // Format ke string jika perlu (misalnya 'YYYY-MM-DD HH:mm:ss')
    const pad = (n) => n.toString().padStart(2, "0");
    const currentDateTime = `${jakartaTime.getFullYear()}-${pad(jakartaTime.getMonth() + 1)}-${pad(jakartaTime.getDate())} ${pad(jakartaTime.getHours())}:${pad(jakartaTime.getMinutes())}:${pad(jakartaTime.getSeconds())}`;

    try {
      const response = await axios.post(UPDATE_API, {
        nim,
        waktu_kehadiran: currentDateTime,
      });

      if (response.data.status === "success") {
        toast.success("Kehadiran berhasil diupdate!");
        fetchDataWisuda();
      } else {
        toast.error("Gagal memperbarui kehadiran!");
      }
    } catch (error) {
      console.error("Error updating attendance:", error);
      toast.error("Terjadi kesalahan saat memperbarui kehadiran.");
    }
  };

  const filteredData = dataWisuda.filter((item) => {
    const term = searchTerm.toLowerCase();
    return (
      item.nama.toLowerCase().includes(term) ||
      item.nim.toLowerCase().includes(term) ||
      item.fakultas.toLowerCase().includes(term) ||
      item.jurusan.toLowerCase().includes(term)
    );
  });
  
  const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);
  const displayedData = filteredData.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );  

  const changePage = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const convertToJakartaTime = (utcString) => {
    const date = new Date(utcString);
    date.setHours(date.getHours() );
    const tanggal = date.toLocaleDateString("id-ID");
    const jam = date.toLocaleTimeString("id-ID", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
    return { tanggal, jam };
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const handleShowResume = () => {
    const total = dataWisuda.length;
    const hadirData = dataWisuda
      .filter(item => item.kehadiran)
      .sort((a, b) => new Date(a.kehadiran) - new Date(b.kehadiran));
  
    const awal = hadirData.slice(0, 5);
    const akhir = hadirData.slice(-5).reverse();
  
    setResumeData({ total, awal, akhir });
    setShowModal(true);
  };

  const exportToExcelDisplayed = () => {
    if (displayedData.length === 0) {
      toast.error("Tidak ada data yang ditampilkan untuk diekspor.");
      return;
    }
  
    const formattedData = displayedData.map((item, index) => {
      const kehadiran = item.kehadiran ? convertToJakartaTime(item.kehadiran) : { tanggal: "", jam: "" };
      return {
        No: index + 1 + (currentPage - 1) * ITEMS_PER_PAGE,
        NIM: item.nim,
        Nama: item.nama,
        Fakultas: item.fakultas,
        Jurusan: item.jurusan,
        WhatsApp: item.whatsapp,
        Email: item.email,
        "QR Code": item.qr_code_data,
        "Tanggal Daftar": new Date(item.date_created).toLocaleDateString("id-ID"),
        "Tanggal Kehadiran": kehadiran.tanggal,
        "Jam Kehadiran": kehadiran.jam,
      };
    });
  
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data Ditampilkan");
    XLSX.writeFile(workbook, "data_ditampilkan.xlsx");
  };
  
  const exportToExcelAll = () => {
    if (dataWisuda.length === 0) {
      toast.error("Tidak ada data untuk diekspor.");
      return;
    }
  
    const formattedData = dataWisuda.map((item, index) => {
      const kehadiran = item.kehadiran ? convertToJakartaTime(item.kehadiran) : { tanggal: "", jam: "" };
      return {
        No: index + 1,
        NIM: item.nim,
        Nama: item.nama,
        Fakultas: item.fakultas,
        Jurusan: item.jurusan,
        WhatsApp: item.whatsapp,
        Email: item.email,
        "QR Code": item.qr_code_data,
        "Tanggal Daftar": new Date(item.date_created).toLocaleDateString("id-ID"),
        "Tanggal Kehadiran": kehadiran.tanggal,
        "Jam Kehadiran": kehadiran.jam,
      };
    });
  
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Semua Data");
    XLSX.writeFile(workbook, "data_semua.xlsx");
  };
  
  const jumlahHadir = dataWisuda.filter(
    (item) => item.kehadiran && item.kehadiran.trim() !== ""
  ).length;  

  const openConfirmModal = (nim) => {
    setSelectedNim(nim);
    setShowConfirmModal(true);
  };
  
  const confirmDelete = async () => {
    try {
      const response = await axios.post(
        "https://graduation.rlagency.id/api/api-admin/delete-data.php",
        { nim: selectedNim }
      );
  
      if (response.data.status === "success") {
        toast.success("Data berhasil dihapus.");
        fetchDataWisuda();
      } else {
        toast.error("Gagal menghapus data.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Terjadi kesalahan saat menghapus data.");
    } finally {
      setShowConfirmModal(false);
      setSelectedNim(null);
    }
  };

  const [showDuplicatesModal, setShowDuplicatesModal] = useState(false);
  const [duplicatesData, setDuplicatesData] = useState([]);

  const handleShowDuplicates = () => {
    const duplicates = findDuplicatesByName(dataWisuda);
    setDuplicatesData(duplicates);
    setShowDuplicatesModal(true);
  };
  
  // Fungsi untuk mencari data yang memiliki nama duplikat
  const findDuplicatesByName = (data) => {
    const nameCount = {};
    data.forEach((item) => {
      if (nameCount[item.nama]) {
        nameCount[item.nama].push(item);
      } else {
        nameCount[item.nama] = [item];
      }
    });
    return Object.values(nameCount).filter((items) => items.length > 1);
  };  

  return (
    <div className="container">
      <h2>Pembekalan Wisuda</h2>

      <InputGroup className="mb-3">
        <InputGroupText>Cari</InputGroupText>
        <Input
            placeholder="Nama, NIM, Fakultas, atau Jurusan"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
        />
      </InputGroup>

      <div className="d-flex gap-2 mb-3">
        <Button color="info" className="mb-3" onClick={handleShowResume}>
          Resume Data
        </Button>
        <Button color="success" className="mb-3" onClick={exportToExcelDisplayed}>
          Export Data
        </Button>
        <Button color="primary" className="mb-3" onClick={exportToExcelAll}>
          Export All
        </Button>
        <Button color="warning" className="mb-3" onClick={handleShowDuplicates}>
          Duplicates
        </Button>
      </div>

      <ToastContainer position="top-right" autoClose={3000} />

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
        <div className="table-responsive table-responsive-wrapper">
          <table className="applicants-table">
            <thead>
              <tr>
                <th>No</th>
                <th>NIM</th>
                <th>Nama</th>
                <th>Fakultas</th>
                <th>Jurusan</th>
                <th>Chat</th>
                <th>Mail</th>
                {/* <th>QR Code</th>
                <th>Tgl Daftar</th>
                <th>Tanggal Kehadiran</th> */}
                <th>Token</th>
                <th>Jam Kehadiran</th>
                <th>Update</th>
                <th>Hapus</th>
              </tr>
            </thead>
            <tbody>
              {displayedData.length > 0 ? (
                displayedData.map((item, index) => {
                  const kehadiran = item.kehadiran
                    ? convertToJakartaTime(item.kehadiran)
                    : { tanggal: "", jam: "" };

                  return (
                    <tr key={item.id}>
                      <td>{(currentPage - 1) * ITEMS_PER_PAGE + index + 1}</td>
                      <td>{item.nim}</td>
                      <td>{item.nama}</td>
                      <td>{item.fakultas}</td>
                      <td>{item.jurusan}</td>
                      <td>
                      <a
                          className="whatsapp-link"
                          href={`https://wa.me/${item.whatsapp}?text=${encodeURIComponent(
                            `📢 PEMBEKALAN WISUDA UPI YPTK 📢

                        Berikut data anda:
                        🎓 NIM: ${item.nim}
                        🔐 TOKEN / Secret Code: ${item.token}

                        ⚠️ Token bersifat RAHASIA. Jangan bagikan kepada siapapun.

                        Untuk mengunduh QR Code kembali, silakan kunjungi:
                        https://graduation.rlagency.id/re-download

                        Lalu masukkan NIM dan TOKEN anda.`
                          )}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FaWhatsapp size={16} />
                        </a>

                      </td>
                      <td>
                        <a href={`mailto:${item.email}`}>
                          <FaEnvelope size={14} color="#007bff" />
                        </a>
                      </td>
                      {/* <td>{item.qr_code_data}</td>
                      <td>{new Date(item.date_created).toLocaleDateString("id-ID")}</td>
                      <td>{kehadiran.tanggal}</td> */}
                      <td>{item.token}</td>
                      <td>{kehadiran.jam}</td>
                      <td>
                        <button
                          className="btn-update"
                          onClick={() => handleUpdateKehadiran(item.nim)}
                        >
                          Update
                        </button>
                      </td>
                      <td>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => openConfirmModal(item.nim)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="12" className="text-center">Tidak ada data</td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="pagination">
            <button onClick={() => changePage(currentPage - 1)} disabled={currentPage === 1}>Prev</button>
            <span>Halaman {currentPage} dari {totalPages}</span>
            <button onClick={() => changePage(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
          </div>
        </div>
        </>
      )}

      <Modal isOpen={showModal} toggle={() => setShowModal(false)} size="lg" centered>
        <ModalHeader toggle={() => setShowModal(false)}>
          <span className="fw-semibold">📊 Resume Data Pembekalan</span>
        </ModalHeader>
        <ModalBody>
        <div className="mb-3 d-flex gap-4 flex-wrap">
            <div>
              <h5 className="fw-bold mb-1">
                Pendaftar:
              </h5>
              <span className="badge bg-primary fs-6">{resumeData.total}</span>
            </div>
            <div>
              <h5 className="fw-bold mb-1">
                Hadir:
              </h5>
              <span className="badge bg-success fs-6">{jumlahHadir}</span>
            </div>
          </div>

          <div className="mb-4">
            <h6 className="fw-semibold text-muted mb-2">🕒 5 Kehadiran Paling Awal</h6>
            <table className="table table-sm table-bordered align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Nama</th>
                  <th>NIM</th>
                  <th>Jam Kehadiran</th>
                </tr>
              </thead>
              <tbody>
                {resumeData.awal.map((item, i) => (
                  <tr key={`awal-${i}`}>
                    <td>{i + 1}</td>
                    <td>{item.nama}</td>
                    <td>{item.nim}</td>
                    <td>
                      <span className="badge bg-success">
                        {convertToJakartaTime(item.kehadiran).jam}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div>
            <h6 className="fw-semibold text-muted mb-2">🕔 5 Kehadiran Paling Akhir</h6>
            <table className="table table-sm table-bordered align-middle">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Nama</th>
                  <th>NIM</th>
                  <th>Jam Kehadiran</th>
                </tr>
              </thead>
              <tbody>
                {resumeData.akhir.map((item, i) => (
                  <tr key={`akhir-${i}`}>
                    <td>{i + 1}</td>
                    <td>{item.nama}</td>
                    <td>{item.nim}</td>
                    <td>
                      <span className="badge bg-danger">
                        {convertToJakartaTime(item.kehadiran).jam}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setShowModal(false)}>
            Tutup
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={showConfirmModal} toggle={() => setShowConfirmModal(false)} centered>
        <ModalHeader toggle={() => setShowConfirmModal(false)}>
          Konfirmasi Penghapusan
        </ModalHeader>
        <ModalBody>
          Apakah Anda yakin ingin menghapus data dengan NIM <strong>{selectedNim}</strong>?
          Tindakan ini tidak dapat dibatalkan.
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setShowConfirmModal(false)}>
            Batal
          </Button>
          <Button color="danger" onClick={confirmDelete}>
            Ya, Hapus
          </Button>
        </ModalFooter>
      </Modal>


      <Modal isOpen={showDuplicatesModal} toggle={() => setShowDuplicatesModal(false)} size="lg" centered>
        <ModalHeader toggle={() => setShowDuplicatesModal(false)}>
          Duplicates - Peserta dengan Nama yang Sama
        </ModalHeader>
        <ModalBody>
          <div>
            {duplicatesData.length > 0 ? (
              duplicatesData.map((duplicateGroup, index) => (
                <div key={index}>
                  <h5>Nama: {duplicateGroup[0].nama}</h5>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>NIM</th>
                        <th>Fakultas</th>
                        <th>Jurusan</th>
                        <th>Token</th>
                      </tr>
                    </thead>
                    <tbody>
                      {duplicateGroup.map((item, i) => (
                        <tr key={item.id}>
                          <td>{i + 1}</td>
                          <td>{item.nim}</td>
                          <td>{item.fakultas}</td>
                          <td>{item.jurusan}</td>
                          <td>{item.token}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ))
            ) : (
              <p>Tidak ada data duplikat.</p>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setShowDuplicatesModal(false)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

    </div>
  );
};

export default PembekalanWisuda;
